import { Component, Story, Knobs } from './DocTypes';

const knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  allowFullSwipe: {
    default: false,
    editor: 'checkbox',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic swipeout',

  coreComponent_v3: {
    html: `<tag3-mobile-swipeout {{...knobs}}>
  <div style="display: flex; padding: 16px;">
    <p>I can be swiped left or right</p>
  </div>
</tag3-mobile-swipeout>
<br />
<div>
    <tag3-button id="enableButton">Enable</tag3-button>
    <tag3-button id="resetButton">Reset</tag3-button>
</div>
`,
    js: `var swipeout = document.querySelector('tag3-mobile-swipeout');
  var enableButton = document.querySelector('#enableButton');
  var resetButton = document.querySelector('#resetButton');
  swipeout.leftOptions = [
  { 
    name: "reject",
    icon: "CrossThin", 
    label: "Reject", 
  }];
  swipeout.rightOptions = [
    { 
      name: "maybe",
      icon: "QuestionMark", 
      label: "Maybe",
      accent: "denim"
    },
    { 
      name: "accept",
      icon: "TickThin", 
      label: "Accept",
      accent: "keppel"
    }
  ];
  swipeout.addEventListener('optionClick', function(e) {
    console.log(e.detail.name)
    if (e.detail.name === "accept") {
      swipeout.rightOptions = [
      { 
        name: "maybe",
        icon: "QuestionMark", 
        label: "Maybe",
        accent: "denim"
      },
      { 
        name: "accept",
        icon: "TickThin", 
        label: "Processing",
        accent: "keppel"
      }]
    }
    if (e.detail.name === "reject") {
      swipeout.leftOptions = [
      { 
        name: "reject",
        icon: "CrossThin", 
        label: "Processing", 
      }];
    }
  });
  enableButton.addEventListener('buttonClick', function() {
    swipeout.disabled = false;
  });
  resetButton.addEventListener('buttonClick', function() {
    swipeout.reset();
  });`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<div>
  <TagMobileSwipeout id="tagMobileSwipeout" {{...knobs}}
    leftOptions={[
      { 
        name: "reject",
        icon: "CrossThin", 
        label: "Reject", 
      }
    ]}
    rightOptions={[
      { 
        name: "maybe",
        icon: "QuestionMark", 
        label: "Maybe",
        accent: "denim"
      },
      { 
        name: "accept",
        icon: "TickThin", 
        label: "Accept",
        accent: "keppel"
      }
    ]} 
  >
    <div style={{ display: "flex", padding: "16px" }}>
      <p>I can be swiped left or right</p>
    </div>
  </TagMobileSwipeout>
  <br />
  <div>
      <Tag3Button id="enableButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").disabled = false }}>Enable</Tag3Button>
      <Tag3Button id="resetButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").reset() }}>Reset</Tag3Button>
  </div>
</div>`,
    knobs: {
      ...knobs,
    },
  },
};

const RightOnlyStory: Story = {
  title: 'Only right option',
  description: 'A basic swipeout with two options on the right',

  coreComponent_v3: {
    html: `<tag3-mobile-swipeout {{...knobs}}>
  <div style="display: flex; padding: 16px;">
    <p>I can only be swiped left</p>
  </div>
</tag3-mobile-swipeout>
<br />
<div>
    <tag3-button id="enableButton">Enable</tag3-button>
    <tag3-button id="resetButton">Reset</tag3-button>
</div>
`,
    js: `var swipeout = document.querySelector('tag3-mobile-swipeout');
  var enableButton = document.querySelector('#enableButton');
  var resetButton = document.querySelector('#resetButton');
  swipeout.rightOptions = [
    { 
      name: "more",
      icon: "MoreMobile", 
      label: "More",
      accent: "porcelain",
      iconAccent: "title"
    }
  ];
  enableButton.addEventListener('buttonClick', function() {
    swipeout.disabled = false;
  });
  resetButton.addEventListener('buttonClick', function() {
    swipeout.reset();
  });`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<div>
  <TagMobileSwipeout id="tagMobileSwipeout" {{...knobs}}
    rightOptions={[
      { 
        name: "more",
        icon: "MoreMobile", 
        label: "More",
        accent: "porcelain",
        iconAccent: "title"
      }
    ]}
  >
    <div style={{ display: "flex", padding: "16px" }}>
      <p>I can only be swiped left</p>
    </div>
  </TagMobileSwipeout>
  <br />
  <div>
      <Tag3Button id="enableButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").disabled = false }}>Enable</Tag3Button>
      <Tag3Button id="resetButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").reset() }}>Reset</Tag3Button>
  </div>
</div>`,
    knobs: {
      ...knobs,
    },
  },
};

const LeftOnlyStory: Story = {
  title: 'Only left option',
  description: 'A basic swipeout with a single option on the left',

  coreComponent_v3: {
    html: `<tag3-mobile-swipeout {{...knobs}}>
  <div style="display: flex; padding: 16px;">
    <p>I can only be swiped right</p>
  </div>
</tag3-mobile-swipeout>
<br />
<div>
    <tag3-button id="enableButton">Enable</tag3-button>
    <tag3-button id="resetButton">Reset</tag3-button>
</div>
`,
    js: `var swipeout = document.querySelector('tag3-mobile-swipeout');
  var enableButton = document.querySelector('#enableButton');
  var resetButton = document.querySelector('#resetButton');
  swipeout.leftOptions = [
  { 
    name: "reject",
    icon: "CrossThin", 
    label: "Reject", 
  }];
  enableButton.addEventListener('buttonClick', function() {
    swipeout.disabled = false;
  });
  resetButton.addEventListener('buttonClick', function() {
    swipeout.reset();
  });`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<div>
  <TagMobileSwipeout id="tagMobileSwipeout" {{...knobs}}
    leftOptions={[
      { 
        name: "reject",
        icon: "CrossThin", 
        label: "Reject", 
      }
    ]}
  >
    <div style={{ display: "flex", padding: "16px" }}>
      <p>I can only be swiped right</p>
    </div>
  </TagMobileSwipeout>
  <br />
  <div>
      <Tag3Button id="enableButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").disabled = false }}>Enable</Tag3Button>
      <Tag3Button id="resetButton" onButtonClick={() => { document.querySelector("#tagMobileSwipeout").reset() }}>Reset</Tag3Button>
  </div>
</div>`,
    knobs: {
      ...knobs,
    },
  },
};

export const TagMobileSwipeoutDocs: Component = {
  type: 'component',
  name: 'mobile-swipeout',
  description:
    'Renders a swipeout to be used on mobile device, allowing you to show options to the user',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
    {
      name: 'disabled',
      description: 'Whether the swipeout is disabled',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'allowFullSwipe',
      description:
        'Whether the user can do a full swipe and automatically activate the outer action',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'optionClick',
      description:
        'Triggers when an option is clicked. This will also set te disabled prop as true.',
      parameters: [],
    },
    {
      name: 'swipeOpened',
      description: 'Triggers when a swipe starts',
      parameters: [],
    },
    {
      name: 'fullSwipeWillOccur',
      description: 'Triggers when a full swipe option will be used when the swipe is released',
      parameters: [],
    },
    {
      name: 'fullSwipeWillNotOccur',
      description:
        'Triggers when a full swipe option will no longer be used when the swipe is released',
      parameters: [],
    },
  ],
  methods: [
    {
      name: 'reset',
      description: 'Will reset the swipeout to its initial state, and re-enable it',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [BasicStory, RightOnlyStory, LeftOnlyStory],
};
